export default "__VITE_ASSET__cf35a600__"